export const CONFIG = {
    cdnBaseUrl: process.env.CDN_URL,
    cdnUrl: `${process.env.CDN_URL}${process.env.CDN_PREFIX ? `/${process.env.CDN_PREFIX}` : ''}`,
    apiUrl: process.env.API_URL,
};

export const surveySettingsDefaults = {
    displayTime: 'immediately',
    secondsAfterLoad: 0,
    displayOn: 'both',
    visibility: 'always',
    proportionOfUsers: 100,
    scrollPercentage: 50,
};
